(function( global, $ ) {
    $(document).on('click', '[gr-popup]', function(event) {
        event.preventDefault();

        var winHeight = 400,
            winWidth = 600,
            winTop = ($(window).height() / 2) - (winHeight / 2),
            winLeft = ($(window).width() / 2) - (winWidth / 2),
            url = $(this).attr('href');

        window.open(url, '_blank', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    });
}( window.groots, jQuery ));
